import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { Icon } from "@utdanningsdirektoratet/icon";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";
import styles from "./DetailedList.module.less";

type DetailedListProps = {
  title?: React.ReactNode | string;
  summary?: React.ReactNode | string;
  className?: string;
  closeable?: boolean;
  closed?: boolean;
  children?: React.ReactNode;
};

const DetailedList: React.FC<DetailedListProps> = ({ title, summary, closeable, className, children, ...rest }) => {
  const [closed, setClosed] = React.useState(rest.closed || false);

  const onClick = (): void => {
    setClosed((prevState) => !prevState);
  };

  const onHeaderClick = (): void => {
    if (closed) onClick();
  };

  const onKeyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === " " || e.key === "Enter") {
      onHeaderClick();
    }
  };

  const detailedListClass = cls(
    {
      [styles.detailedListClosed]: closed,
    },
    className
  );

  return (
    <div className={detailedListClass}>
      {title ? (
        <div
          tabIndex={closed ? 0 : -1}
          role="button"
          className={styles.detailedListHeader}
          onClick={onHeaderClick}
          onKeyDown={onKeyDownHandler}
        >
          <h2 className={styles.detailedListTitle}>{title}</h2>

          <div className={styles.detailedListSummary}>{summary}</div>

          {closeable ? (
            <div className={styles.detailedListClose}>
              <Tooltip disabled={closed} message="Lukk">
                <button type="button" aria-label="Lukk" className={styles.detailedListCloseButton} onClick={onClick}>
                  <Icon icon="cross" />
                </button>
              </Tooltip>
            </div>
          ) : null}
        </div>
      ) : null}

      <div className={styles.detailedListList}>{children}</div>
    </div>
  );
};

export default DetailedList;
